export const FormatPhoneNo = (value: string) => {
  const digits = value.replace(/\D/g, '').slice(0, 8)

  if (digits.length <= 3) return digits
  if (digits.length <= 5) return `${digits.slice(0, 3)} ${digits.slice(3)}`
  return `${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5)}`
}
